import { IStaticProps } from 'core-components/sitebuilder/models/IWidget'

export const EMPTY_OBJECT_DATA: IStaticProps = {
  paramName: '',
  paramValue: '',
  paramType: 'string',
}
